import { type RouteObject, createBrowserRouter } from "react-router";
import { AppShell } from "./components/AppShell";
import { PLATFORM_PAGES } from "./lib/seo";
import CalculatorPage from "./routes/Calculator";
import ComparePage from "./routes/Compare";
import DeleteDataPage from "./routes/DeleteData";
import PrivacyPage from "./routes/Privacy";
import SavedPage from "./routes/Saved";
import SettingsPage from "./routes/Settings";
import TermsPage from "./routes/Terms";

export const routes: RouteObject[] = [
  {
    element: <AppShell />,
    children: [
      { index: true, element: <CalculatorPage /> },
      ...PLATFORM_PAGES.map((page) => ({ path: page.path.slice(1), element: <CalculatorPage seo={page} /> })),
      { path: "compare", element: <ComparePage /> },
      { path: "saved", element: <SavedPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "terms", element: <TermsPage /> },
      { path: "privacy", element: <PrivacyPage /> },
      { path: "delete-data", element: <DeleteDataPage /> },
      { path: "*", element: <CalculatorPage /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
